import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

interface SelectStatusProps {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    allowClear?: boolean;
}

const SelectStatus: React.FC<SelectStatusProps> = ({
    value,
    onChange,
    label = "Status",
    allowClear = true
}) => {
    const handleChange = (e: SelectChangeEvent<string>) => {
        onChange(e.target.value);
    };

    const handleClear = () => {
        onChange('');
    };

    return (
        <FormControl fullWidth color="secondary">
            <InputLabel>{label}</InputLabel>
            <Select
                value={value}
                label={label}
                onChange={handleChange}
                endAdornment={
                    allowClear && value ? (
                        <IconButton
                            size="small"
                            onClick={handleClear}
                            sx={{ marginRight: 1 }}
                            aria-label="Limpar seleção"
                        >
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    ) : null
                }
            >
                <MenuItem value="Pendente">Pendente</MenuItem>
                <MenuItem value="Planejada">Planejada</MenuItem>
                <MenuItem value="Em Andamento">Em Andamento</MenuItem>
                <MenuItem value="Finalizada">Finalizada</MenuItem>
                <MenuItem value="Cancelado">Cancelado</MenuItem>
            </Select>
        </FormControl>
    );
};

export default SelectStatus;
